import { useContext } from 'react'
import { ShouldDisplayAnimationContext } from '@/context'

export const useEntryAnimation = () => useContext(ShouldDisplayAnimationContext)